import { ClienteViewModel } from './clienteViewModel';

export class ListadoClientes {
    clientes: Array<ClienteViewModel>;
    total: number;
    prevLink: string;
    nextLink: string;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/listadoClientes.ts